import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { ProductionComponent } from "./marche/corporate/production/production.component";
import { GlobalProductiviteComponent } from "./global/global-productivite/global-productivite.component";
import { ProductionComponent as ProductionCreditComponent } from "./credit/production/production.component";
import { QualityOfServiceComponent as QualityOfServiceCreditComponent } from "./credit/quality-of-service/quality-of-service.component";
import { DossierComponent as DossierCreditComponent } from "./credit/dossier/dossier.component";
import { PartProductionComponent } from "./marche/particulier/part-production/part-production.component";
import { ProfProductionComponent } from "./marche/professionnel/prof-production/prof-production.component";

import { DepartProductiviteComponent } from "./departement/depart-productivite/depart-productivite.component";
import { JurProductionComponent } from "./direction-juridique/jur-production/jur-production.component";
import { JurQosComponent } from "./direction-juridique/jur-qos/jur-qos.component";
import { JurProductiviteComponent } from "./direction-juridique/jur-productivite/jur-productivite.component";
import { DossiersCardListComponent as JuridiqueDossiersCardListComponent } from "./direction-juridique/dossiers-card-list/dossiers-card-list.component";

import { DossiersCardListComponent as ParticulierDossiersCardListComponent } from "./marche/particulier/dossiers-card-list/dossiers-card-list.component";
import { DossiersCardListComponent as CorporateDossiersCardListComponent } from "./marche/corporate/dossiers-card-list/dossiers-card-list.component";
import { DossiersCardListComponent as ProfessionnelDossiersCardListComponent } from "./marche/professionnel/dossiers-card-list/dossiers-card-list.component";
import { DossiersCardListComponent as CreditDossiersCardListComponent } from "./credit/dossiers-card-list/dossiers-card-list.component";


import { PpProductionComponent } from "./marche/product-program/pp-production/pp-production.component";
import { PpQosComponent } from "./marche/product-program/pp-qos/pp-qos.component";
import { PpProductiviteComponent } from "./marche/product-program/pp-productivite/pp-productivite.component";
import { ProfProductiviteComponent } from "./marche/professionnel/prof-productivite/prof-productivite.component";
import { ProfQosComponent } from "./marche/professionnel/prof-qos/prof-qos.component";
import { PartQosComponent } from "./marche/particulier/part-qos/part-qos.component";
import { PartProductiviteComponent } from "./marche/particulier/part-productivite/part-productivite.component";
import { ProductiviteComponent } from "./marche/corporate/productivite/productivite.component";
import { CorpQosProduitComponent } from "./marche/corporate/qos/corp-qos-produit/corp-qos-produit.component";
import { GlobalPortefeuilleComponent } from "./global/global-portefeuille/global-portefeuille.component";
import { MonPortefeuilleComponent } from "./personnel/mon-portefeuille/mon-portefeuille.component";
import { DossiersCardListComponent } from "./personnel/dossiers-card-list/dossiers-card-list.component";
import { CreditProductiviteComponent } from './credit/credit-productivite/credit-productivite.component';
import { ContentieuxComponent } from './suivi-portefeuille/contentieux/contentieux.component';
import { CreanceRestructureComponent } from './suivi-portefeuille/creance-restructure/creance-restructure.component';
import { DossierRecouvrementComponent } from './suivi-portefeuille/dossier-recouvrement/dossier-recouvrement.component';
import { PortefeuilleRisqueComponent } from './suivi-portefeuille/portefeuille-risque/portefeuille-risque.component';
import { PreContentieuxComponent } from './suivi-portefeuille/pre-contentieux/pre-contentieux.component';
import { DossierImpayeComponent } from './suivi-portefeuille/dossier-impaye/dossier-impaye.component';
import { DossierProvisonComponent } from './suivi-portefeuille/dossier-provison/dossier-provison.component';
import { PerformanceComponent } from './personnel/performance/performance.component';

const routes: Routes = [
  /*{
    path: "new-dashboard",
    children: []
  },*/

  {
    path: "new-dashboard",
    redirectTo: "personnel/performance",
    pathMatch: "full"
  },

  /*{
    path: "",
    data: { breadcrumb: "Dashboard" },
    children: [*/
      //personnel
      {
        path: "",
        redirectTo: "personnel/performance",
        pathMatch: "full"
      },
      {
        path: "personnel/mon-portefeuille",
        component: MonPortefeuilleComponent,
        data: { breadcrumb: "Personnel -> Mon portefeuille" }
      },
      {
        path: "personnel/dossiers-card-list",
        component: DossiersCardListComponent,
        data: { breadcrumb: "Personnel -> Liste dossiers" }
      },
      {
        path: "personnel/performance",
        component: PerformanceComponent,
        data: { breadcrumb: "Personnel -> Mes performances" }
      },
      //personnel

      //global
      {
        path: "global/portefeuille",
        component: GlobalPortefeuilleComponent,
        data: { breadcrumb: "Global -> Productivité" }
      },
      {
        path: "global/productivite",
        component: GlobalProductiviteComponent,
        data: { breadcrumb: "Global -> Productivité" }
      },
      //global

      //departement
      {
        path: "departement/productivite",
        component: DepartProductiviteComponent,
        data: { breadcrumb: "Département" }
      },
      //département

      //direction-juridique
      {
        path: "direction-juridique/production",
        component: JurProductionComponent,
        data: { breadcrumb: "Production" }
      },
      {
        path: "direction-juridique/qos",
        component: JurQosComponent,
        data: { breadcrumb: "QOS" }
      },
      {
        path: "direction-juridique/productivite",
        component: JurProductiviteComponent,
        data: { breadcrumb: "Productivite" }
      },
      {
        path: "direction-juridique/dossiers-card-list",
        component: JuridiqueDossiersCardListComponent,
        data: { breadcrumb: "Dossier" }
      },
      //direction-juridique

      //suivi portefeuille
      {
        path: "suivi-portefeuille/contentieux",
        component: ContentieuxComponent,
        data: { breadcrumb: "contentieux" }
      },
      {
        path: "suivi-portefeuille/creance-restructure",
        component: CreanceRestructureComponent,
        data: { breadcrumb: "creance-restructure" }
      },
      {
        path: "suivi-portefeuille/dossier-recouvrement",
        component: DossierRecouvrementComponent,
        data: { breadcrumb: "dossier-recouvrement" }
      },
      {
        path: "suivi-portefeuille/portefeuille-risque",
        component: PortefeuilleRisqueComponent,
        data: { breadcrumb: "portefeuille-risque" }
      },

      {
        path: "suivi-portefeuille/pre-contentieux",
        component: PreContentieuxComponent,
        data: { breadcrumb: "pre-contentieux" }
      },

      {
        path: "suivi-portefeuille/dossier-impaye",
        component: DossierImpayeComponent,
        data: { breadcrumb: "Impayé" }
      },

      {
        path: "suivi-portefeuille/dossier-provision",
        component: DossierProvisonComponent,
        data: { breadcrumb: "Provision" }
      },
      //suivi portefeuille

      //corporate
      {
        path: "marche/corporate/production",
        component: ProductionComponent,
        data: { breadcrumb: "Corporate -> Production" }
      },
      {
        path: "marche/corporate/quality-of-service",
        component: CorpQosProduitComponent,
        data: { breadcrumb: "Crédit -> QOS" }
      },
      {
        path: "marche/corporate/productivite",
        component: ProductiviteComponent,
        data: { breadcrumb: "Crédit -> Productivité" }
      },
      {
        path: "marche/corporate/dossiers-card-list",
        component: CorporateDossiersCardListComponent,
        data: { breadcrumb: "Dossier" }
      },
      //corporate

      //credit
      {
        path: "credit",
        children: [
          {
            path: "production",
            component: ProductionCreditComponent,
            data: { breadcrumb: "Crédit -> Production" }
          },
          {
            path: "dossiers-card-list",
            component: CreditDossiersCardListComponent,
            data: { breadcrumb: "Crédit -> Dossier" }
          },
          {
            path: "quality-of-service",
            component: QualityOfServiceCreditComponent,
            data: { breadcrumb: "Crédit -> QOS" }
          },
          {
            path: "productivite",
            component: CreditProductiviteComponent,
            data: { breadcrumb: "Crédit -> Productivite" }
          }
        ]
      },
      //credit

      //particulier
      {
        path: "particulier/production",
        component: PartProductionComponent,
        data: { breadcrumb: "Particulier -> Production" }
      },
      {
        path: "particulier/productivite",
        component: PartProductiviteComponent,
        data: { breadcrumb: "Professionnel -> productivite" }
      },
      {
        path: "particulier/qos",
        component: PartQosComponent,
        data: { breadcrumb: "Professionnel -> qos" }
      },

      {
        path: "marche/particulier/dossiers-card-list",
        component: ParticulierDossiersCardListComponent,
        data: { breadcrumb: "Dossier" }
      },
      //particulier

      //professionnel
      {
        path: "professionnel/production",
        component: ProfProductionComponent,
        data: { breadcrumb: "Professionnel -> Production" }
      },
      {
        path: "professionnel/productivite",
        component: ProfProductiviteComponent,
        data: { breadcrumb: "Professionnel -> productivite" }
      },
      {
        path: "professionnel/qos",
        component: ProfQosComponent,
        data: { breadcrumb: "Professionnel -> qos" }
      },
      {
        path: "marche/professionnel/dossiers-card-list",
        component: ProfessionnelDossiersCardListComponent,
        data: { breadcrumb: "Dossier" }
      },
      //professionnel

      //product-program
      {
        path: "product-program/production",
        component: PpProductionComponent,
        data: { breadcrumb: "Product-Program -> Production" }
      },
      {
        path: "product-program/qos",
        component: PpQosComponent,
        data: { breadcrumb: "Product-Program -> QOS" }
      },
      {
        path: "product-program/productivite",
        component: PpProductiviteComponent,
        data: { breadcrumb: "Product-Program -> Productivité" }
      }
      //product-program
    /*]
  }*/
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NewDashboardRoutingModule {}
